import { useState } from "react";
import { toast } from "sonner";
import { DoorOpen, Check, X, Eye } from "lucide-react";
import { api } from "../lib/api";
import { DECISION_TEMPLATES, fillTemplate } from "../lib/decisionTemplates";
import { Button } from "./ui/button";

const TPL = DECISION_TEMPLATES.find((t) => t.key === "resign_accept");
const days = (a, b) => Math.max(0, Math.round((new Date(b) - new Date(a)) / 86400000));

export const ResignRequests = ({ items, employees, company, onAccept, onChanged, onView }) => {
  const [dates, setDates] = useState({});
  const pending = items.filter((d) => d.resignation?.status === "pending");
  if (!pending.length) return null;
  const today = new Date().toISOString().slice(0, 10);
  const val = (d, k) => dates[d.id]?.[k] ?? (k === "date" ? today : d.resignation.last_day);
  const setVal = (d, k, v) => setDates((p) => ({ ...p, [d.id]: { ...p[d.id], [k]: v } }));
  const accept = (d) => {
    const emp = (employees || []).find((e) => e.id === d.employee_id) || { name: d.employee_name };
    const date = val(d, "date");
    const last = val(d, "last");
    onAccept({ type: TPL.type, title: TPL.title, date, employee_id: d.employee_id, require_signature: true,
      body_html: fillTemplate(TPL.body, emp, { company: company?.name || "الشركة", date, request_date: d.date, last_day: last, notice_days: days(d.date, last) }),
      resign_request_id: d.id, resign_last_day: last });
  };
  const reject = async (d) => {
    const reason = window.prompt(`سبب رفض استقالة ${d.employee_name}`, "");
    if (reason === null) return;
    try { await api.rejectResignation(d.id, reason); toast.success("تم رفض الطلب وإشعار الموظف"); onChanged(); }
    catch (e) { toast.error(e?.response?.data?.detail || "تعذّر الرفض"); }
  };
  return (
    <div className="rounded-2xl border border-red-200 bg-gradient-to-l from-red-50 to-white p-3" data-testid="resign-requests">
      <p className="mb-2 flex items-center gap-1.5 text-sm font-extrabold text-red-800"><DoorOpen className="h-4 w-4" /> طلبات استقالة جديدة ({pending.length})</p>
      <div className="space-y-2">
        {pending.map((d) => (
          <div key={d.id} className="flex flex-wrap items-center gap-2 rounded-xl border border-red-100 bg-white px-3 py-2" data-testid={`resign-req-${d.id}`}>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-bold text-slate-800">{d.employee_name} <span className="text-xs font-normal text-slate-400">#{d.number} · موقّع ✓</span></p>
              <p className="truncate text-xs text-slate-500">السبب: {d.resignation.reason} · آخر يوم مقترح: <b dir="ltr">{d.resignation.last_day}</b></p>
            </div>
            <label className="flex items-center gap-1 text-[11px] text-slate-500">تاريخ القرار
              <input type="date" value={val(d, "date")} onChange={(e) => setVal(d, "date", e.target.value)} className="h-8 rounded-md border border-slate-200 px-1.5 text-xs" data-testid={`resign-date-${d.id}`} /></label>
            <label className="flex items-center gap-1 text-[11px] text-slate-500">آخر يوم عمل
              <input type="date" value={val(d, "last")} onChange={(e) => setVal(d, "last", e.target.value)} className="h-8 rounded-md border border-slate-200 px-1.5 text-xs" data-testid={`resign-last-${d.id}`} /></label>
            <Button size="sm" variant="ghost" onClick={() => onView(d)} className="h-8 gap-1" data-testid={`resign-view-${d.id}`}><Eye className="h-3.5 w-3.5" /> الطلب</Button>
            <Button size="sm" onClick={() => accept(d)} className="h-8 gap-1 bg-emerald-600 hover:bg-emerald-700" data-testid={`resign-accept-${d.id}`}><Check className="h-3.5 w-3.5" /> قبول</Button>
            <Button size="sm" variant="outline" onClick={() => reject(d)} className="h-8 gap-1 border-red-300 text-red-700" data-testid={`resign-reject-${d.id}`}><X className="h-3.5 w-3.5" /> رفض</Button>
          </div>
        ))}
      </div>
    </div>
  );
};
